import { Consignment as ConsignmentType } from 'types';
import { getLocalStorageItem, setLocalStorageItem } from 'helpers';
import { LocalStorageKeys, STATUSES } from 'commons';
import { Template, TemplateOptions, getContent } from './notificationTemplates';

interface Props {
  variant: Template;
  options?: TemplateOptions;
  onClick?: () => void;
}

export function sendNotification({ variant, options, onClick }: Props): void {
  if (!('Notification' in window)) return;

  function notify() {
    const { title, config } = getContent(variant, options);

    const notification = new Notification(title, config);
    notification.addEventListener('click', () => {
      // eslint-disable-next-line no-restricted-globals
      parent.focus();
      window.focus();
      if (onClick) onClick();
    });
  }

  if (Notification.permission === 'granted') {
    notify();
  } else if (Notification.permission !== 'denied') {
    Notification.requestPermission((permission) => {
      if (permission === 'granted') {
        notify();
      }
    });
  }
}

export function checkIfConsignmentCanBeNotified(
  consignments: ConsignmentType[] | undefined,
  storage: LocalStorageKeys
) {
  let alreadyNotifiedConsignments: ConsignmentType[];
  let consignmentsToNotify: ConsignmentType[];

  if (!consignments?.length) {
    return { alreadyNotifiedConsignments: [], consignmentsToNotify: [] };
  }

  alreadyNotifiedConsignments = getLocalStorageItem(storage, []);

  if (alreadyNotifiedConsignments.length) {
    const stillActive = alreadyNotifiedConsignments.filter(
      (alreadyNotifiedConsignment) =>
        alreadyNotifiedConsignment.consignmentStatus ===
        STATUSES.AVAILABLE_FOR_STORE.value
    );
    setLocalStorageItem(storage, stillActive);
  }

  consignmentsToNotify = consignments?.filter((newConsignment) =>
    alreadyNotifiedConsignments.every(
      (notifiedConsignment) =>
        notifiedConsignment?.consignmentCode !== newConsignment?.consignmentCode
    )
  );

  return { alreadyNotifiedConsignments, consignmentsToNotify };
}

export function updateNotifiedConsignments(
  alreadyNotifiedConsignments: ConsignmentType[],
  consignmentsToNotify: ConsignmentType[],
  storage: LocalStorageKeys
) {
  const notifiedConsignments = alreadyNotifiedConsignments.concat(
    consignmentsToNotify ?? []
  );

  setLocalStorageItem(storage, notifiedConsignments);
}

export { Template };
